var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoreVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 11.365a1.817 1.817 0 010 3.632 1.817 1.817 0 010-3.632zm0-5.191a1.826 1.826 0 010 3.65 1.826 1.826 0 010-3.65zm0-5.171a1.81 1.81 0 11-.001 3.617A1.81 1.81 0 018 1.003z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDExLjM2NWExLjgxNyAxLjgxNyAwIDAxMCAzLjYzMiAxLjgxNyAxLjgxNyAwIDAxMC0zLjYzMnptMC01LjE5MWExLjgyNiAxLjgyNiAwIDAxMCAzLjY1IDEuODI2IDEuODI2IDAgMDEwLTMuNjV6bTAtNS4xNzFhMS44MSAxLjgxIDAgMTEtLjAwMSAzLjYxN0ExLjgxIDEuODEgMCAwMTggMS4wMDN6Ii8+Cjwvc3ZnPgo=";
export { SvgMoreVertical as ReactComponent };